import { request } from "services/api/util";

class PrivilegeService {
  async getListPrivileges(param) {
    const config = {
      method: "get",
      url: `admin/privilege`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createOrUpdatePrivilege(body, id, update) {
    let config;
    if (update) {
      config = {
        method: "put",
        url: `admin/privilege/${id}`,
        data: body,
        headers: {
          "content-type": "	application/json;charset=UTF-8",
        },
      };
    } else {
      config = {
        method: "post",
        url: `admin/privilege`,
        data: body,
        headers: {
          "content-type": "	application/json;charset=UTF-8",
        },
      };
    }
    return request(config);
  }

  async getDetailPrivilege(id) {
    const config = {
      method: "get",
      url: `admin/privilege/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getListSubBundle(params) {
    const config = {
      method: "get",
      url: `admin/privilege/subBundles`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getListPrivilegeTypes() {
    const config = {
      method: "get",
      url: `admin/privilegeTypes`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new PrivilegeService();
